import { Loader2 } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export default function ReferralsTable({ referrals, isLoading, formatDate }) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-[#FFD700]" />
      </div>
    );
  }

  return (
    <Table data-testid="referrals-table">
      <TableHeader>
        <TableRow className="border-b border-[#222] hover:bg-transparent">
          <TableHead className="text-[#FFD700] font-bold uppercase tracking-wider text-xs">Namn</TableHead>
          <TableHead className="text-[#FFD700] font-bold uppercase tracking-wider text-xs">E-post</TableHead>
          <TableHead className="text-[#FFD700] font-bold uppercase tracking-wider text-xs">Ambassadör-kod</TableHead>
          <TableHead className="text-[#FFD700] font-bold uppercase tracking-wider text-xs">Registrerad</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {referrals.length === 0 ? (
          <TableRow>
            <TableCell colSpan={4} className="text-center text-gray-500 py-12">
              Inga biljettköp ännu
            </TableCell>
          </TableRow>
        ) : (
          referrals.map((ref, index) => (
            <TableRow 
              key={ref.id} 
              className="border-b border-[#1A1A1A] hover:bg-[#1A1A1A]/50" 
              data-testid={`referral-row-${index}`}
            >
              <TableCell className="text-white font-medium">{ref.name}</TableCell>
              <TableCell className="text-gray-400">{ref.email}</TableCell>
              <TableCell>
                <span className="px-2 py-1 bg-[#FFD700]/20 text-[#FFD700] text-xs rounded font-medium font-mono">
                  {ref.ambassador_code || ref.ambassador}
                </span>
              </TableCell>
              <TableCell className="text-gray-500 text-sm">{formatDate(ref.timestamp)}</TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}
